<template>
    <div class="card shadow"
         :class="type === 'dark' ? 'bg-default': ''">
        <div class="card-header border-0"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
                        {{title}}
                    </h3>
                </div>
            </div>
        </div>

        <div class="table-responsive">
            <base-table class="table align-items-center table-flush"
                        :class="type === 'dark' ? 'table-dark': ''"
                        :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                        tbody-classes="list"
                        :data="tableData">
                <template slot="columns">
                    <th>Name</th>
                    <th>Description</th>
                    <th>NDC</th>
                    <th>Company</th>
                    <th></th>
                </template>

                <template slot-scope="{row}">

                    <th scope="row">
                        <div class="media align-items-center">
                            <a href="#" class="avatar rounded-circle mr-3">
                                <img alt="" :src="row.img" style="height:100%;object-fit:cover;">
                            </a>
                            <div class="media-body">
                                <span class="name mb-0 text-sm">{{row.name}}</span>
                            </div>
                        </div>
                    </th>
                    <td>
                        {{row.description}}
                    </td>
                    <td>
                        {{row.ndc}}
                    </td>
                    <td>
                        {{row.company}}
                    </td>

                    <td class="text-right">
                        <base-dropdown class="dropdown"
                                       position="right">
                            <a slot="title" class="btn btn-sm btn-icon-only text-light" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i class="fas fa-ellipsis-v"></i>
                            </a>

                            <template>
                                <a class="dropdown-item" href="#">Action</a>
                                <a class="dropdown-item" href="#">Another action</a>
                                <a class="dropdown-item" href="#">Something else here</a>
                            </template>
                        </base-dropdown>
                    </td>

                </template>

            </base-table>
        </div>

    </div>
</template>
<script>
    export default {
        name: 'projects-table',
        props: {
            type: {
                type: String
            },
            title: String
        },
        mounted() {
            this.$Amplify.Auth.currentUserInfo()
                .then(data => {
                    if (data) {
                        this.axios.get(`Drug/AllPackages`)
                            .then(response => {
                                let drugs = response.data;
                                this.tableData = drugs.map(d => {
                                    return {
                                        img: d.imageUrl,
                                        name: d.productName,
                                        description: d.packageDescription,
                                        ndc: d.ndc,
                                        company: d.company.name,
                                    };
                                });
                            });
                    }
                });


        },
        data() {
            return {
                tableData: [
                ]
            }
        }
    }
</script>
<style>
</style>
